module.exports = __webpack_public_path__ + "img/8m.b3795429.png";